import { VideoListItem } from "./VideoListItem";
import { Box, Link, Typography } from "@mui/material";
import { FilterChips } from "./FilterChips";
import { CourseStructureCtx, DbUser, SkillDetails, UserCtx } from "../../../interfaces";
import { useContext, useState } from "react";
import { SkillVideoModal } from "../SkillVideoModal";
import { useHistory, useLocation } from "react-router-dom";
import { ExplorePageNoResultMessage, Role } from "../../../enums";
import { generateGtmEvent } from "../../../Helpers";
import { CourseStructureContext } from "../../../context/CourseStructureContext";
import { UserContext } from "../../../context/UserContext";

interface VideoListContainerProps {
  pageType: string;
  videoList: SkillDetails[];
  videoListTitle?: string;

  filterChips?: any[];

  onFilterRemove?: (filter: any) => void;
}

export const VideoListContainer = (props: VideoListContainerProps) => {
  let { pageType, videoList, videoListTitle, filterChips, onFilterRemove } = props;
  let courseStructureCtx = useContext(CourseStructureContext) as CourseStructureCtx;
  let userCtx = useContext(UserContext) as UserCtx;
  let currentUser = userCtx.dbUser as DbUser;
  const [skillVideoModalOpen, setSkillVideoModalOpen] = useState(false);
  const [playVideoIndex, setPlayVideoIndex] = useState(0);
  let location = useLocation();
  let isModulePage = location.pathname === "/explore/module";
  let queryParams = new URLSearchParams(location.search);
  const moduleQuery = queryParams.get("moduleId") as string;
  const history = useHistory();
  let handleViewModulePageClick = () => {
    if (currentUser.role === Role.student) {
      history.push("/modules?moduleId=" + moduleQuery);
      return;
    }
    history.push({
      pathname: "/explore/activities",
      search: `?module=${moduleQuery}&courseId=${
        courseStructureCtx.courseTreeStructure?.getCurrentCourse().id
      }&content=1`,
    });
  };

  const HandleDataLayer = (section: string) => {
    generateGtmEvent({
      event: "link",
      action: "click",
      name: "onclick",
      type: "internal link",
      region: "main content",
      section: section,
      text: "view module page",
      component: "explore",
    });
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          marginTop: "32px",
          marginBottom: "40px",
        }}>
        {videoListTitle && (
          <Typography
            variant="h3"
            sx={{
              marginLeft: "10px",
              fontWeight: "bold",
            }}>
            {videoListTitle}
          </Typography>
        )}
        {filterChips && filterChips.length > 0 && (
          <FilterChips filters={filterChips} onFilterRemove={onFilterRemove} />
        )}
        {isModulePage && moduleQuery && (
          <Link
            onClick={() => {
              HandleDataLayer(videoListTitle ? videoListTitle : "explore");
              handleViewModulePageClick();
            }}
            sx={{ marginLeft: "10px", marginTop: "-8px" }}
            variant="body1">
            View module page
          </Link>
        )}
        {videoList && videoList.length > 0 ? (
          videoList.map((video, index) => {
            return (
              <VideoListItem
                key={index}
                onClick={() => {
                  generateGtmEvent({
                    event: "modal",
                    action: "open",
                    name: "onclick",
                    type: "click",
                    region: "main content",
                    section: videoListTitle ? videoListTitle : "explore",
                    text: `${video.title}`,
                  });
                  setSkillVideoModalOpen(true);
                  setPlayVideoIndex(index);
                }}
                skillVideoDetails={video}
                onBookmarkClick={(skillTitle, toggleState) => {
                  generateGtmEvent({
                    event: "select",
                    action: toggleState ? "click" : "unclick",
                    name: "onclick",
                    type: "checkbox",
                    region: "main content",
                    section: skillTitle,
                    text: toggleState ? "Save video" : "remove from saved videos",
                    component: videoListTitle ? videoListTitle : "explore",
                  });
                }}
              />
            );
          })
        ) : (
          <Typography variant="body1" sx={{ marginLeft: "10px" }}>
            {ExplorePageNoResultMessage[pageType]}
          </Typography>
        )}
      </Box>
      <SkillVideoModal
        open={skillVideoModalOpen}
        skills={videoList}
        onClose={() => setSkillVideoModalOpen(false)}
        showControls={true}
        showBottomNavigation={false}
        playVideoIndex={playVideoIndex}
        gtmSection={videoListTitle ? videoListTitle : "explore"}
      />
    </>
  );
};
